import { createSelector } from 'reselect';
import State from 'types/state';

const getModalId = (state: State) => state.modals.modalId;

export default createSelector([getModalId], (modalId) => ({
  modalId,
}));
